<div *ngLet="langChange$ | async" class="main-container">
  <app-left-text-block
    *ngLet="catalogCount$ | async as catalogCount"
    [title]="
      catalogCount
        ? catalogCount + ' ' + (catalogCount | dw: 'DATA.TABLE_FILTER.SET':'DATA.TABLE_FILTER.SET_GENITIVE':'DATA.TABLE_FILTER.SETS' | translate)
        : ''
    "
    iconName="main-header-people"
    [text]="headerText"
    [defaultTitleHeight]="36"
    [transitionName]="'MAIN.TO_DATASETS' | translate"
    transitionLink="/opendata"
    textColorClass="primary-color-50"
    [textClasses]="'body-1 white-color'"
    [titleClasses]="'h1 white-color mb12'"
  >
    <ng-container *ngTemplateOutlet="authButtons; context: { light: true }"></ng-container>
  </app-left-text-block>

  <div class="resident-carousel">
    <div class="backing"></div>
    <div class="carousel-container">
      <app-small-card-block
        *ngLet="popularDatasets$ | async as popularDatasets"
        textColorClass="primary-color-50"
        [smallCardData]="{
          title: 'MAIN.POPULAR_AND_NEW_DATASETS',
          icon: icons.EmptyStar,
          data: null
        }"
        [smallCardAllData]="popularDatasets"
      ></app-small-card-block>
    </div>
  </div>

  <app-right-text-block
    class="wo-border-radius"
    iconName="residents"
    [title]="'MAIN.FOR_RESIDENTS' | translate"
    [text]="civiliansText"
    [transitionName]="'MAIN.TO_DATASETS' | translate"
    transitionLink="/opendata"
    [catalogFilter]="residentsParams"
  >
    <ng-container *ngTemplateOutlet="authButtons"></ng-container>
  </app-right-text-block>
  <div [ngStyle]="{ 'min-height': !isRuLocale ? '370px' : '' }" class="autumn-container" [class.open]="isMapOpen" #map>
    <div class="carousel-container">
      <app-small-card-block
        *ngLet="seasonDatasets$ | async as seasonDatasets"
        [smallCardData]="{
          title: 'MAIN.SEASONAL_DATASETS_FOR_RESIDENTS',
          icon: icons.Autumn32,
          data: null
        }"
        [criteria]="seasonDatasetsCriteria$ | async"
        criteriaLink="/opendata"
        [class.floating-dataset]="isDatasetOpen"
        [isFloating]="isDatasetOpen"
        [smallCardAllData]="seasonDatasets"
        [clickable]="true"
        (cardClick)="onMapCardClick()"
        [hasShowDownloads]="true"
        [grayHideScroll]="true"
      ></app-small-card-block>
      <ng-container *ngLet="(breakPointObserve$ | async)?.matches">
        <app-map-carousel-wrapper
          *ngIf="isRuLocale"
          (mapOpen)="isMapOpen = $event"
          (datasetOpen)="isDatasetOpen = $event"
          (closeCard)="carouselMapComponent ? (carouselMapComponent.selectedObjectId = null) : ''"
          (backISelectedItem)="carouselMapComponent?.backSelectedItem()"
          (sizeСonversionCard)="sizeConversionCard($event)"
        >
          <ng-container *ngLet="currentMap$ | async as currentMap">
            <app-map
              *ngIf="!(loadingSeasonsData$ | async)"
              [isRecommendationDisabled]="!(catalogInfo$ | async)"
              [mapGeoData]="currentMap"
              [defaultNextMyData]="defaultIsNextMeData"
              [isRecommendationData]="isRecommendationData"
              [showZoomControl]="true"
              [showFilterMenu]="true"
              (clickOnObject)="showCard($event)"
              (clickOnRecommendation)="onRecommendationClick($event)"
              (clickOnNextMeData)="onNextMeDataClick($event)"
            ></app-map>
          </ng-container>
        </app-map-carousel-wrapper>
      </ng-container>
    </div>
  </div>

  <app-left-text-block
    [textClasses]="'body-1'"
    [titleClasses]="'h2'"
    [title]="'MAIN.FOR_DEVELOPERS' | translate"
    iconName="developers"
    [text]="developersText"
    [transitionName]="'MAIN.API_DOCUMENTATION' | translate"
    transitionLink="/developers/documentation"
  >
    <a class="btn-primary big td-n center" routerLink="/developers">{{ 'MAIN.DEVELOPERS_ACCOUNT' | translate }}</a>
  </app-left-text-block>

  <ng-container *ngLet="popularApps$ | async as popularApps">
    <app-mobile-apps-block
      *ngIf="isRuLocale"
      (selectstart)="$event.preventDefault()"
      (mousedown)="$event.preventDefault()"
      [popularApps]="popularApps"
    >
    </app-mobile-apps-block>
  </ng-container>

  <!--<app-right-text-block
    iconName="experts"
    [title]="'OTHER.FOR_EXPERTS' | translate"
    [text]="expertText"
    [transitionName]="'OTHER.TO_DATASETS' | translate"
    transitionLink="/opendata"
    [catalogFilter]="catalogFilter"
  >
    <ng-container *ngTemplateOutlet="authButtons"></ng-container>
  </app-right-text-block>-->

  <app-vk-block></app-vk-block>

  <!--  <app-useful-links></app-useful-links>-->

  <app-footer></app-footer>
</div>

<ng-template #authButtons let-light="light">
  <ng-container *ngIf="!(isAuthenticated$ | async)">
    <!--  <button class="btn-primary big" (click)="openAuthorizationDialog()">Зарегистрироваться</button>-->
    <button class="btn-secondary big" (click)="openAuthorizationDialog()" [class.light-btn]="light">{{ 'MAIN.ENTER' | translate }}</button>
  </ng-container>
</ng-template>
